module.exports = __webpack_public_path__ + "img/Concierge.ba65b67a.jpg";